// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3814d19e","831":"f2120999"}[chunkId] + ".chunk.js";
};